import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Helper to format URL segment => "user-add" -> "User Add"
const formatSegment = (segment) => {
  return segment
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const CommonBreadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Split and filter path segments
  const pathSegments = pathname
    .split('/')
    .filter(Boolean)
    .filter(segment => isNaN(segment));

  // Build full paths for each breadcrumb segment
  const fullPaths = pathSegments.map((_, index) =>
    '/' + pathSegments.slice(0, index + 1).join('/')
  );

  
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-2 page-header">
      <ol className="breadcrumb mb-0 bg-transparent">
        {/* Show "Dashboard" if at root path */}
        {pathSegments.length === 0 ? (
          <li className="breadcrumb-item active">
            <span>Dashboard</span>
          </li>
        ) : (
          fullPaths.map((path, index) => {
            const isLast = index === fullPaths.length - 1;
            const segment = pathSegments[index];
            const segmentName = formatSegment(segment);

            // Determine if the segment should be a link or just text
            // Action segments (edit, add) are usually not valid landing pages on their own
            const isActionSegment = segment.includes('edit') || segment.includes('add');

            return (
              <li
                key={index}
                className={`breadcrumb-item ${isLast ? 'active' : ''}`}
              >
                {isLast || isActionSegment ? (
                  <span>{segmentName}</span>
                ) : (
                  <Link to={path}>{segmentName}</Link>
                )}
              </li>
            );
          })
        )}
      </ol>
    </div>
  );
};

export default CommonBreadcrumb;
